import TaskApi from "../../../service/TaskService";
import LeadPartyApi from "../../../service/LeadPartyService";
import ProcessApi from "../../../service/ProcessService";
import CompleteTaskRequest from "../../../service/request/CompleteTaskRequest";
import GetMyActiveTaskRequest from "../../../service/request/GetMyActiveTaskRequest";
import StartProcessByNameRequest from "../../../service/request/StartProcessByNameRequest";

export default {
  name: "AllAuthAndVideoCall",
  mixins: [],
  data: function () {
    return {
      checkedItems: [],
      stateValues: {
        showChooseProcessDialog: false,
        showAssignToInitiatorDialog: false,
        showAssignProcessDialog: false,
        showLinkSentDialog: false,
        showJoiningVideoCallDialog: false,
        showUserCardDialog: false,
        showAddNoteDialog: false,
        showDropAssigneeDialog: false,
        showSendLinkWarn: false,
        leadPartyId: 0,
        processId: "",
        primaryContactType: "",
        fullName: "",
        meetingId: "",
        tckn: "",
        taskId: "",
        modeOfDeletion: null,
        inDeletingMode: false,
        deleteWarningSubText: "",
        note: {}
      },
      deleteLoading: false,
      showDeleteWarn: false
    };
  },
  mounted: async function () {
    const taskId = this.$route.params.taskId;

    if (taskId) {
      await this.completeTask(taskId);
      this.$refs.table.getData();
    }
  },
  methods: {
    completeTask: function (taskId) {
      const completeTaskRequest = new CompleteTaskRequest();
      completeTaskRequest.taskId = taskId;
      return new Promise(resolve => {
        TaskApi.completeTask(this, completeTaskRequest, () => {
          resolve(true);
        });
      });
    },
    onClickChooseProcess(id) {
      this.stateValues.leadPartyId = id;
      this.stateValues.showChooseProcessDialog = true;
    },
    onClickAssignToInitiator(id,taskId) {
      this.stateValues.processId = id;
      this.stateValues.taskId = taskId;
      this.stateValues.showAssignToInitiatorDialog = true;
    },
    onCloseChooseProcessDialog() {
      this.stateValues.showChooseProcessDialog = false;
      this.stateValues.leadPartyId = 0;
    },
    onCloseAssignToInitiatorDialog() {
      this.stateValues.showAssignToInitiatorDialog = false;
      this.stateValues.processId = 0;
      this.$refs.table.getData();
    },
    onClickJoinVideoCall(
      fullName,
      tckn,
      leadPartyId,
      processId,
      primaryContactType
    ) {
      this.stateValues.fullName = fullName;
      this.stateValues.meetingId = this.generateUniqueRoomName(processId);
      this.stateValues.tckn = tckn;
      this.stateValues.leadPartyId = leadPartyId;
      this.stateValues.processId = processId;
      this.stateValues.primaryContactType = primaryContactType;
      this.stateValues.showJoiningVideoCallDialog = true;
    },
    onClickAttemptJoinVideoCall() {
      this.$router.push({
        name: "VideoConversation",
        params: {
          roomName: this.stateValues.meetingId,
          tckn: this.stateValues.tckn,
          leadPartyId: this.stateValues.leadPartyId,
          primaryContactType: this.stateValues.primaryContactType
        }
      });
    },
    onClickCancelJoinVideoCall() {
      this.stateValues.showJoiningVideoCallDialog = false;
      this.stateValues.fullName = "";
      this.stateValues.meetingId = "";
      this.stateValues.tckn = "";
      this.stateValues.leadPartyId = 0;
      this.stateValues.primaryContactType = "";
    },
    onProcessIdCreated() {
      this.stateValues.showLinkSentDialog = true;
      this.$refs.table.getData();
    },
    onCloseLinkSentDialog() {
      this.stateValues.showLinkSentDialog = false;
      this.$router.push({
        name: "AllAuthAndVideoCall"
      });
    },
    onClickCustomerCard(leadPartyId, tckn, processId, note) {
      this.stateValues.leadPartyId = leadPartyId;
      this.stateValues.tckn = tckn;
      this.stateValues.processId = processId;
      this.stateValues.showUserCardDialog = true;
      this.stateValues.note = note;
    },
    onClickOkCustomerCard() {
      this.stateValues.showUserCardDialog = false;
      this.stateValues.processId = "";
      this.stateValues.tckn = "";
      this.stateValues.leadPartyId = 0;
      this.stateValues.note = null;
    },
    onClickAddNote(processId) {
      this.stateValues.processId = processId;
      this.stateValues.showAddNoteDialog = true;
    },
    onClickDropAssignee(processId, leadPartyId) {
      this.stateValues.processId = processId;
      this.stateValues.leadPartyId = leadPartyId;
      this.stateValues.showDropAssigneeDialog = true;
    },
    toggleWarnButtons(mode) {
      if (mode === "process") {
        this.stateValues.modeOfDeletion = "process";
      } else if (mode === "lead") {
        this.stateValues.modeOfDeletion = "lead";
      }
      this.stateValues.inDeletingMode = !this.stateValues.inDeletingMode;
    },
    async onClickCompleteProcess() {
      if (this.checkedItems.length !== 0) {
        this.deleteLoading = true;
        if (this.stateValues.modeOfDeletion === "lead") {
          await this.deleteLeadPartys(
            this.checkedItems.map(leadParty => leadParty.id).join(",")
          );
        } else if (this.stateValues.modeOfDeletion === "process") {
          if (this.checkedItems.length === 1) {
            await this.deleteProcessByLeadId(
              this.checkedItems[0].processId,
              this.checkedItems[0].leadParty.id
            );
          }
        }
        this.stateValues.inDeletingMode = false;
        this.deleteLoading = false;
        this.showDeleteWarn = false;
        this.$refs.table.getData();
        this.checkedItems = [];
      }
    },
    onClickDeleteButton() {
      this.stateValues.deleteWarningSubText =
        this.stateValues.modeOfDeletion === "process" ?
        this.$t("processDeleteWarnSub") :
        this.$t("deleteWarnSub");
      this.showDeleteWarn = true;
    },
    onClickCancelProcess() {
      this.showDeleteWarn = false;
    },
    onClickCloseAddNoteDialog() {
      this.stateValues.taskId = "";
      this.stateValues.showAddNoteDialog = false;
    },
    onClickCloseDropAssigneeDialog() {
      this.stateValues.leadPartyId = "";
      this.stateValues.taskId = "";
      this.stateValues.showDropAssigneeDialog = false;
      this.$refs.table.getData();
    },
    onClickSendLink(processId, leadPartyId) {
      this.stateValues.processId = processId;
      this.stateValues.leadPartyId = leadPartyId;
      this.stateValues.showSendLinkWarn = true;
    },
    onClickCompleteSendLink() {
      const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
      getMyActiveTaskRequest.processId = this.stateValues.processId;

      TaskApi.getMyActiveTask(
        this,
        getMyActiveTaskRequest,
        response => {
          const startProcessByNameRequest = new StartProcessByNameRequest();
          startProcessByNameRequest.processName = "DEEP_LINK_SUB_PROCESS";
          startProcessByNameRequest.variables = [{
              code: "notifyProcessId",
              value: response.activeResourceTask.processId
            },
            {
              code: "leadId",
              value: this.stateValues.leadPartyId
            }
          ];

          ProcessApi.startProcessByName(
            this,
            startProcessByNameRequest,
            () => {
              this.closeSendLinkDialog();
            },
            error => {
              console.log(error);
            }
          );
        },
        error => {
          console.log(error);
        }
      );
    },
    onClickCancelSendLink() {
      this.closeSendLinkDialog();
    },
    closeSendLinkDialog() {
      this.stateValues.leadPartyId = "";
      this.stateValues.processId = "";
      this.stateValues.showSendLinkWarn = false;
    },
    deleteLeadPartys(ids) {
      return new Promise(resolve => {
        LeadPartyApi.deleteMultiple(
          this,
          ids,
          response => {
            if (response && response.deleteds) {
              resolve(response.deleteds);
            }
            resolve();
          },
          error => {
            console.log(error);
            resolve();
          }
        );
      });
    },
    deleteProcessByLeadId(processId, leadId) {
      return new Promise(resolve => {
        LeadPartyApi.deleteProcessByLeadId(
          this,
          processId,
          leadId,
          response => {
            resolve();
          },
          error => {
            console.log(error);
            resolve();
          }
        );
      });
    },
    generateUniqueRoomName(processId) {
      return `${
        this.$store.getters["user"].domainCode
      }-${processId}-${new Date().getTime()}`;
    },
    setCheckedItems(items) {
      this.checkedItems = items;
    },
    onClickAssignProcess(id) {
      this.stateValues.processId = id;
      this.stateValues.showAssignProcessDialog = true;
    },
    onCloseAssignProcessDialog() {
      this.stateValues.showAssignProcessDialog = false;
      this.stateValues.processId = 0;
      this.$refs.table.getData();
    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/authandvideocall/mixin/AllAuthAndVideoCall.js